// Cookie Management JS

/* Manage Cookies */

export default class Cookies {
  /* eslint-disable class-methods-use-this */
  setCookie(name, value, days = 7, path = '/') {
    /* eslint-disable max-len */
    const exDays = days * 24 * 60 * 60 * 1000;
    const expires = new Date(Date.now() + exDays).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=${path}`;
  }

  getCookie(name) {
    return document.cookie.split('; ').reduce((rValue, vValue) => {
      const parts = vValue.split('=');
      return parts[0] === name ? decodeURIComponent(parts[1]) : rValue;
    }, '');
  }

  deleteCookie(name, path = '/') {
    this.setCookie(name, '', - 1, path);
  }
}
